import APICall from "../utils/APICall"

export default class ChequeServices {
    static listComplicancePnd = async (page, pageLimit, search, from, to) => {
        return await APICall(`/api/ComplianceSheet/admin/list-account_on_compliance_pnd?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}`, "GET")
    }

    static createCompliancePnd = async (data) => {
        return await APICall(`/api/ComplianceSheet/admin/logTo_Compliance_Pnd`, "POST", data)
    }
}